import React, { memo } from 'react';
import { useSlate } from 'slate-react';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';

// History's button component
// @format: string | format's type
// @icon: string | icon's type
const History = memo(({ format, icon }) => {
	// Get current editor
	const editor = useSlate();

	// Check if highlight selection is disabled
	const isDisabled = format === 'undo'
		? editor.isUndoDisabled()
		: editor.isRedoDisabled();

	// Concat classnames
	const cls = classnames(
		isDisabled
			? 'text-neutral-400 dark:text-neutral-700'
			: 'text-neutral-800 dark:text-white',
		'w-9 h-9 leading-9 rounded-lg text-xl text-center cursor-pointer transition-colors'
	);

	// Handle mark's button click
	const onClick = event => {
		event.preventDefault();
		return format === 'undo' ? editor.undo() : editor.redo();
	};

	return (
		<Icon
			icon={icon}
			className={cls}
			onClick={onClick}
			disabled={isDisabled}
		/>
	);
});

export default History;
